module.exports = __webpack_public_path__ + "img/ITA.d8f7d3e5.svg";